module.exports = __webpack_public_path__ + "static/img/worth_0.471868d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/worth_0.jpg
// module id = xWl9
// module chunks = 1